export const SvgStepDefault = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.0003 18.3334C14.6027 18.3334 18.3337 14.6024 18.3337 10C18.3337 5.39765 14.6027 1.66669 10.0003 1.66669C5.39795 1.66669 1.66699 5.39765 1.66699 10C1.66699 14.6024 5.39795 18.3334 10.0003 18.3334Z"
      fill="#98A2B3"
    />
    <path
      d="M8.81719 12.9834C8.65052 12.9834 8.49219 12.9167 8.37552 12.8001L6.01719 10.4417C5.77552 10.2001 5.77552 9.80008 6.01719 9.55841C6.25885 9.31675 6.65885 9.31675 6.90052 9.55841L8.81719 11.4751L13.1005 7.19175C13.3422 6.95008 13.7422 6.95008 13.9839 7.19175C14.2255 7.43341 14.2255 7.83341 13.9839 8.07508L9.25885 12.8001C9.14219 12.9167 8.98385 12.9834 8.81719 12.9834Z"
      fill="white"
    />
  </svg>
);

export const SvgStepCompleted = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.0003 18.3334C14.6027 18.3334 18.3337 14.6024 18.3337 10C18.3337 5.39765 14.6027 1.66669 10.0003 1.66669C5.39795 1.66669 1.66699 5.39765 1.66699 10C1.66699 14.6024 5.39795 18.3334 10.0003 18.3334Z"
      fill="#7C68FB"
    />
    <path
      d="M8.81719 12.9834C8.65052 12.9834 8.49219 12.9167 8.37552 12.8001L6.01719 10.4417C5.77552 10.2001 5.77552 9.80008 6.01719 9.55841C6.25885 9.31675 6.65885 9.31675 6.90052 9.55841L8.81719 11.4751L13.1005 7.19175C13.3422 6.95008 13.7422 6.95008 13.9839 7.19175C14.2255 7.43341 14.2255 7.83341 13.9839 8.07508L9.25885 12.8001C9.14219 12.9167 8.98385 12.9834 8.81719 12.9834Z"
      fill="white"
    />
  </svg>
);

export const SvgStepLoader = () => (
  <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1.66699 7.25C1.66699 10.5637 4.35328 13.25 7.66699 13.25C10.9807 13.25 13.667 10.5637 13.667 7.25C13.667 3.93629 10.9807 1.25 7.66699 1.25"
      stroke="url(#paint0_linear_643_1148)"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <linearGradient id="paint0_linear_643_1148" x1="4.25" y1="9.25" x2="9" y2="1.25" gradientUnits="userSpaceOnUse">
        <stop stopColor="#7C68FB" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
    </defs>
  </svg>
);

export const SvgStepError = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.99937 0.678406C4.39703 0.678406 0.666016 4.40925 0.666016 9.01176C0.666016 13.6143 4.39703 17.3451 8.99937 17.3451C13.6017 17.3451 17.3327 13.6143 17.3327 9.01176C17.3327 4.40925 13.6017 0.678406 8.99937 0.678406ZM8.99937 4.84508C9.45962 4.84508 9.83271 5.21842 9.83271 5.67842C9.83271 6.13842 9.45962 6.51175 8.99937 6.51175C8.53912 6.51175 8.16604 6.13842 8.16604 5.67842C8.16604 5.21842 8.53912 4.84508 8.99937 4.84508ZM8.99937 7.34509C9.45962 7.34509 9.83271 7.71842 9.83271 8.17843V12.3451C9.83271 12.8051 9.45962 13.1784 8.99937 13.1784C8.53912 13.1784 8.16604 12.8051 8.16604 12.3451V8.17843C8.16604 7.71842 8.53912 7.34509 8.99937 7.34509Z"
      fill="#F04438"
    />
  </svg>
);
